import { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

function useResetPassword() {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const [loading, setLoading] = useState(false);
  const Navigate = useNavigate();

  const ResetPassword = async (payload) => {
    setLoading(true);
    await axios
      .post(`${BASE_URL}/api/reset-password/`, payload)
      .then((response) => {
        setLoading(false);
        Navigate(`/`);
      })
      .catch((error) => {
        setLoading(false);
        Swal.fire({
          icon: "error",
          text:
            error?.response?.data?.message ||
            "Oops! Something went wrong on our end. Please give us a moment to fix it. Feel free to try again later",
          customClass: {
            confirmButton: "custom-red-button",
          },
        });
      });
  };
  return { ResetPassword, loading };
}
export default useResetPassword;
